module.exports = __webpack_public_path__ + "img/package-chart.e37398cd.svg";